import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GuestLayout from '../components/GuestLayout';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ServicesPage() {
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/services`).then(res => setServices(res.data)).catch(console.error);
  }, []);

  const categories = [...new Set(services.map(s => s.category))];

  return (
    <GuestLayout>
      <div className="px-6 pt-8 max-w-md mx-auto md:max-w-2xl">
        <div className="mb-6 animate-fade-in">
          <h1 data-testid="services-title" className="font-heading text-3xl tracking-tight text-espresso">
            Guest Services
          </h1>
          <p className="text-text-muted text-sm mt-1">Elevate your stay with premium add-ons</p>
        </div>

        {categories.map(cat => (
          <div key={cat} className="mb-8">
            <h2 className="text-xs uppercase tracking-widest text-text-muted font-semibold mb-4">{cat}</h2>
            <div className="flex flex-col gap-4">
              {services.filter(s => s.category === cat).map((service, idx) => (
                <button
                  key={service.id}
                  data-testid={`service-card-${service.id}`}
                  onClick={() => navigate(`/services/${service.id}`)}
                  className="bg-white border border-warm-border rounded-2xl overflow-hidden flex text-left hover:border-warmgold/50 transition-colors card-hover opacity-0 animate-fade-in"
                  style={{ animationDelay: `${idx * 0.05}s` }}
                >
                  <div className="w-28 h-28 flex-shrink-0">
                    <img src={service.image_url} alt={service.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-4 flex-1 flex flex-col justify-center">
                    <h3 className="font-body text-sm font-semibold text-espresso mb-1">{service.title}</h3>
                    <p className="text-text-muted text-xs line-clamp-2 mb-2">{service.description}</p>
                    <p className="text-espresso font-semibold text-sm">${service.price.toFixed(2)}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </GuestLayout>
  );
}
